import ConnectToSlackFirstTimeCode from "!!raw-loader!./placeholders/ConnectToSlackFirstTime.tsx";
import LoadingCode from "!!raw-loader!./placeholders/Loading.tsx";
import RequestErrorCode from "!!raw-loader!./placeholders/RequestError.tsx";
import SearchCode from "!!raw-loader!./placeholders/Search.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import ConnectToSlackFirstTime from "./placeholders/ConnectToSlackFirstTime";
import Loading from "./placeholders/Loading";
import RequestError from "./placeholders/RequestError";
import Search from "./placeholders/Search";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Connect To Slack First Time", ConnectToSlackFirstTimeCode, ConnectToSlackFirstTime),
		paneComponent("Loading Placeholder", LoadingCode, Loading),
		paneComponent("Request Error Placeholder", RequestErrorCode, RequestError),
		paneComponent("Search Placeholder", SearchCode, Search),
	];

	return (
		<Pane
			components={components}
			imports={"import { Placeholder } from \"designSystem/index\";"}
			{...props}
		/>
	);
};